import React, { useRef, useState } from 'react';

import Box from '@tds/core-box';
import Heading from '@tds/core-heading';
import Button from '@tds/core-button';
import TextButton from '@tds/core-text-button';
import Input from '@tds/core-input';

import StatusBar from './statusBar';

import request from '../utils/request';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

const ExistingPhoneNumberCheck = () => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    portabilityTool: {
      labelPortabilityCheck,
      labelNpaNxx,
      hintNpaNxx,
      buttonClear,
      buttonCheck,
      canBePorted,
      cannotBePorted
    }
  } = localizedStrings;

  const [status, setStatus] = useState({
    isVisible: false,
    type: '',
    text: ''
  });
  const inputRef = useRef();
  const handleCheck = () => {
    const valuePhoneNumber = inputRef.current.value;

    if (valuePhoneNumber) {
      request
        .get(`/check-phone?phone=${valuePhoneNumber.replaceAll('-', '')}`)
        .then(response => {
          if (response && response.status === 200) {
            if (response.data && response.data.exists) {
              setStatus({
                type: 'success',
                isVisible: true,
                text: canBePorted
              });
            } else {
              setStatus({
                type: 'error',
                isVisible: true,
                text: cannotBePorted
              });
            }
          } else {
            setStatus({
              type: 'error',
              isVisible: true,
              text: `Response Error`
            });
          }
        })
        .catch(err => {
          setStatus({ type: 'error', isVisible: true, text: err.message });
        });
    }
  };

  const onClear = () => {
    inputRef.current.value = '';
    setStatus({
      ...status,
      isVisible: false
    });
  };

  return (
    <Box between={3}>
      <Heading level="h2" tag="h3">
        {labelPortabilityCheck}
      </Heading>
      <Box tag="fieldset" between={2}>
        <div
          style={{
            display: 'flex'
          }}
        >
          <div style={{ width: '61%' }}>
            <Input
              ref={inputRef}
              label={labelNpaNxx}
              hintPosition="below"
              hint={hintNpaNxx}
            />
          </div>
          <div
            style={{
              width: '20%',
              marginLeft: '1rem',
              paddingTop: '2.8rem'
            }}
          >
            <Button onClick={handleCheck}>{buttonCheck}</Button>
          </div>
          <div
            style={{
              width: '5%',
              marginLeft: '1rem',
              paddingTop: '3.25rem'
            }}
          >
            <TextButton onClick={onClear}>{buttonClear}</TextButton>
          </div>
        </div>
        <div
          style={{
            marginTop: '1rem'
          }}
        >
          {status.isVisible && (
            <StatusBar status={status} setStatus={setStatus} />
          )}
        </div>
      </Box>
    </Box>
  );
};

export default ExistingPhoneNumberCheck;
